import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "card card-notes" }
const _hoisted_2 = { class: "notes--wrapper" }
const _hoisted_3 = { class: "errors" }
const _hoisted_4 = {
  key: 0,
  class: "error"
}
const _hoisted_5 = {
  key: 1,
  class: "error"
}
const _hoisted_6 = {
  key: 2,
  class: "error"
}
const _hoisted_7 = {
  key: 1,
  class: "spinner"
}
const _hoisted_8 = {
  key: 2,
  class: "comment--list"
}
const _hoisted_9 = ["index"]
const _hoisted_10 = { class: "comment" }
const _hoisted_11 = { class: "comment--date" }
const _hoisted_12 = { class: "comment--text" }
const _hoisted_13 = { class: "comment--menu" }
const _hoisted_14 = { class: "wrapper-dots" }
const _hoisted_15 = { class: "menu-option" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "errors" }
const _hoisted_19 = {
  key: 0,
  class: "error"
}
const _hoisted_20 = {
  key: 1,
  class: "error"
}
const _hoisted_21 = {
  key: 2,
  class: "error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("div", { class: "title" }, "Notes")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      ($setup.canManageLot)
        ? (_openBlock(), _createElementBlock("form", {
            key: 0,
            class: "notes--form form-group main-form",
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
          }, [
            _withDirectives(_createElementVNode("textarea", {
              class: _normalizeClass(["textarea notes--textarea", { 'input--error': $setup.v$.note.$error }]),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.note) = $event)),
              placeholder: "Add note"
            }, null, 2), [
              [_vModelText, $setup.note]
            ]),
            _createElementVNode("p", _hoisted_3, [
              ($setup.v$.note.required.$invalid)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString($setup.v$.note.required.$message), 1))
                : ($setup.v$.note.minLength.$invalid)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString($setup.v$.note.minLength.$message), 1))
                  : ($setup.v$.note.maxLength.$invalid)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString($setup.v$.note.maxLength.$message), 1))
                    : _createCommentVNode("", true)
            ]),
            _createElementVNode("button", {
              class: "button default primary little",
              onClick: $setup.addNote
            }, "Add note")
          ], 32))
        : _createCommentVNode("", true),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7))
        : ($setup.comments && $setup.comments.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.comments, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "comment--item",
                  index: index
                }, [
                  (item._id !== $setup.idForEdit)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("div", _hoisted_11, _toDisplayString($setup.dayjs(item.createdAt).format("D MMM YYYY, hh:mm A")), 1),
                          _createElementVNode("div", _hoisted_12, _toDisplayString(item.text), 1)
                        ]),
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode($setup["DropDown"], { placement: 'right bottom' }, {
                              control: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                                _createElementVNode("div", { class: "dots" }, [
                                  _createElementVNode("div", { class: "actions" })
                                ], -1)
                              ]))]),
                              dropdown: _withCtx(() => [
                                _createElementVNode("ul", _hoisted_15, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", {
                                      class: "menu-item edit",
                                      onClick: ($event: any) => ($setup.editComment(item._id, item.text))
                                    }, "Edit", 8, _hoisted_16)
                                  ]),
                                  _createElementVNode("li", null, [
                                    _createElementVNode("div", {
                                      class: "menu-item delete",
                                      onClick: ($event: any) => ($setup.deleteComment(item._id))
                                    }, "Delete", 8, _hoisted_17)
                                  ])
                                ])
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock("form", {
                        key: 1,
                        class: "notes--form form-group",
                        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                      }, [
                        _withDirectives(_createElementVNode("textarea", {
                          class: _normalizeClass(["textarea notes--textarea", { 'input--error': $setup.vEdit$.noteEdit.$error }]),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.noteEdit) = $event)),
                          placeholder: "Edit"
                        }, null, 2), [
                          [_vModelText, $setup.noteEdit]
                        ]),
                        _createElementVNode("p", _hoisted_18, [
                          ($setup.vEdit$.noteEdit.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString($setup.vEdit$.noteEdit.required.$message), 1))
                            : ($setup.vEdit$.noteEdit.minLength.$invalid)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString($setup.vEdit$.noteEdit.minLength.$message), 1))
                              : ($setup.vEdit$.noteEdit.maxLength.$invalid)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString($setup.vEdit$.noteEdit.maxLength.$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", { class: "buttons" }, [
                          _createElementVNode("button", {
                            class: "button default little cancel",
                            onClick: $setup.cancel
                          }, "Cancel"),
                          _createElementVNode("button", {
                            class: "button default primary little",
                            onClick: $setup.confirm
                          }, "Confirm")
                        ])
                      ], 32))
                ], 8, _hoisted_9))
              }), 256))
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}